import _ from 'lodash';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootDispatch, IRootState } from 'stores/rematch/root-store';
import { Badge, Button, Group, Menu } from '@good/ui/core';
import { Bookmark, ChevronDown } from '@good/icons';
import { ICustomView } from 'interfaces/custom-views-interface';

export const BookingViewMenu = () => {
  const dispatch = useDispatch<IRootDispatch>();
  const setHasBookingListingFilterChanged = dispatch.bookingsStore.setHasBookingListingFilterChanged;
  const setBookingListingActiveTab = dispatch.bookingsStore.setBookingListingActiveTab;
  const bookingListingActiveTab = useSelector((state: IRootState) => state.bookingsStore.bookingListingActiveTab);
  const defaultBookingViews = useSelector((state: IRootState) => state.bookingsStore.defaultBookingViews);
  const filterCounters = useSelector((state: IRootState) => state.bookingsStore.filterCounters);
  const displayedBookingListingTabs = useSelector(
    (state: IRootState) => state.bookingsStore.displayedBookingListingTabs,
  );
  const setBookingsFilterV2 = dispatch.bookingsStore.setBookingsFilterV2;
  const isBookingListingLoading = useSelector((state: IRootState) => state.bookingsStore.isBookingListingLoading);
  const setSelectedFilterKey = dispatch.bookingsStore.setSelectedFilterKey;

  const changeTab = useCallback(
    (selectedTabId: string | null) => {
      const activeTab = [...defaultBookingViews, ...displayedBookingListingTabs].find(
        (tab) => tab.customViewId === selectedTabId,
      );
      if (activeTab) {
        setBookingListingActiveTab(activeTab);
        setBookingsFilterV2(activeTab.filterValue);
        setHasBookingListingFilterChanged(false);
        setSelectedFilterKey(activeTab.customViewId);
      }
    },
    [
      defaultBookingViews,
      displayedBookingListingTabs,
      setBookingListingActiveTab,
      setBookingsFilterV2,
      setHasBookingListingFilterChanged,
      setSelectedFilterKey,
    ],
  );

  return (
    <Menu>
      <Menu.Target>
        <Button variant='default' rightSection={<ChevronDown />}>
          {_.get(bookingListingActiveTab, 'name', 'All bookings')}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {defaultBookingViews.map((tab) => {
          const counter = _.find(filterCounters, (counter) => counter.filterName === tab.customViewId);
          return (
            <Menu.Item
              disabled={isBookingListingLoading}
              key={tab.customViewId}
              value={tab.customViewId}
              onClick={() => changeTab(tab.customViewId)}
            >
              <Group wrap='nowrap'>
                {tab.name}{' '}
                {counter !== undefined && (
                  <Badge color='gray.1' c='dark'>
                    {counter.count}
                  </Badge>
                )}
              </Group>
            </Menu.Item>
          );
        })}
        {displayedBookingListingTabs.length > 0 && <Menu.Divider />}
        {displayedBookingListingTabs.map((tab) => {
          const tabCast = tab as ICustomView;
          const counter = _.find(filterCounters, (counter) => counter.filterName === tab.customViewId);
          const customViewId = tab.customViewId;
          if (!customViewId) {
            return null;
          }
          return (
            <Menu.Item
              disabled={isBookingListingLoading}
              key={tab.customViewId}
              value={tab.customViewId}
              onClick={() => changeTab(tabCast.customViewId ?? null)}
            >
              <Group wrap='nowrap' gap={6}>
                {tab.isPinned && <Bookmark />}
                {tab.name}{' '}
                {counter !== undefined && (
                  <Badge color='gray.1' c='dark'>
                    {counter.count}
                  </Badge>
                )}
              </Group>
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
};
